import React, { useState, useEffect, useRef } from 'react';
import Accordian from '../../common/components/Accordian/Accordian.js'
import { formatNumber } from "../../common/util/numberFormatter";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { projects as getProjects } from '../../common/api/projects';
import ProjectsList from "./../Projects/ProjectsList";
import Popover from "../../common/components/popover/popover.js";
import Footer from "./Footer";
import FlightCalculator from "../../common/components/offset/FlightCalculatorV2";
import Modal from "../../common/components/modal/Modal";
import logoGrey from '../../common/media/cc_logo_grey.svg';

const LandingPage = ({ merchantCode, fetchedImpact, oneOfConfig }) => {
    const [projects, setProjects] = useState();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedOneOff, setSelectedOneOff] = useState(null);
    const [selectedCountry] = useState('NZ');

    const showModal = () => {setIsModalVisible(true);};

    const numberOfContributions = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.numberOfContributions?.value);
    const carbonOffsetImpact = fetchedImpact && !fetchedImpact.error && formatNumber(Math.round(fetchedImpact.carbonOffsetImpact?.value));
    const carbonOffsetImpactUnit = fetchedImpact && !fetchedImpact.error && fetchedImpact.carbonOffsetImpact?.unit
    const treeGrowthYears = fetchedImpact && !fetchedImpact.error && formatNumber(fetchedImpact.treeGrowthYears?.value);
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${treeGrowthYears} trees have in one year.`;
    const classContent = `Text here`;
        
    useEffect(() => {
        getProjects(null, merchantCode)
            .then(response => response.json())
            .then(data => setProjects(data))
            .catch(setProjects);

    }, []);

    const scrollToSection = useRef(null);
    const executeScroll = () => scrollToSection.current.scrollIntoView();

    return (
        <div>
            <div className="transparent-header">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12">
                            <a href="https://www.uniqway.com" target="_blank">
                                <img src={`https://res.cloudinary.com/carbonclick/image/upload/v1643268655/Enterprise/Uniqway%20Offsetting%20Program/logo_jemayk.svg`} style={{height: '40px'}} />
                            </a>
                        </div>
                    </div>
                                        
                </div>
            </div>
            <div className="w-100 img-cover hero-img main-banner" >
               
                <div className="container text-align-start">
                    <div className="row align-items-end herorow">
                        <div className="col-md-6 col-sm-7">
                            <div className="text-left">
                                <h1 className="text-primary mt-0">Join us and study in a climate friendly Way!</h1>
                                <p className="text-primary lrg">Our partnership with CarbonClick helps you reduce your environmental impact as you study.</p>
                                <a href="https://www.carbonclick.com/" className="btn-primary">Offset My Emissions</a>
                                <div className="poweredBy">
                                    <span>Powered by</span>
                                    <img src={logoGrey} alt="Carbonclick logo" style={{ height: 24 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="litebg">
                <div className="container">
                    <div className="climateBox">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <img src="https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1643268657/Enterprise/Uniqway%20Offsetting%20Program/study-climate-friendly_euvl9v.png" />
                            </div>
                            <div className="col-lg-6 text-white">
                                <div className="studyContent">
                                    <h2 className="text-white">Study Climate Friendly</h2>
                                    <p>Uniqway is committed to sustainability. We want to give you the tools so you can know your own environmental impact and also how to reduce it.</p>
                                    <p className="mb-0">We’ve committed to double offsetting our annual carbon emissions with CarbonClick and are constandly looking for ways to reduce our environmental impact.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="transactionBOx">
                    <div className="container container-cus">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <h2 className="mt-0">Our Impact</h2>
                            </div>
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <div className="row mobile-hide">
                                        <div className="col-4 d-grid">
                                            <div className="w-100 icn-shdw-bx">
                                                <div>
                                                    <div className="img-cover img-1 w-100">
                                                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1643268656/Enterprise/Uniqway%20Offsetting%20Program/image_59_kpuuxy.png`}/>
                                                    </div>
                                                    <div className="font-bold">
                                                        <h2 className="count-title text-primary">{numberOfContributions}</h2>
                                                        <p className="sml  my-0">Transactions</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-4 d-grid">
                                            <div className="w-100 icn-shdw-bx">
                                                <div>
                                                    <div className="img-cover img-1">
                                                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1643268656/Enterprise/Uniqway%20Offsetting%20Program/image_58_qeugi6.png`} />
                                                    </div>
                                                    <div className="font-bold">
                                                        <h2 className="count-title text-primary">{carbonOffsetImpact} {carbonOffsetImpactUnit}</h2>
                                                        <p className="sml my-0">of CO2 Offset</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-4 d-grid">
                                            <div className="w-100 icn-shdw-bx">
                                                <div>
                                                    <div className="img-cover img-1">
                                                        <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1643268656/Enterprise/Uniqway%20Offsetting%20Program/image_57_o2pqth.png`} />
                                                    </div>
                                                    <div className="font-bold">
                                                        <h2 className="count-title text-primary">{treeGrowthYears}</h2>
                                                        <p className="sml my-0">Tree growth years
                                                            <Popover content={treeMetric} >
                                                                <img className="ml-1" src={`https://res.cloudinary.com/carbonclick/image/upload/v1643369972/Enterprise/Uniqway%20Offsetting%20Program/tooltip_nj5pma.svg`} alt=""/>
                                                            </Popover>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mobile-show mt-4 text-center">
                                        <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                                            <div key="1" >
                                                <div className="w-100 icn-shdw-bx">
                                                    <div>
                                                        <div className="img-cover img-1 w-100">
                                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1643268656/Enterprise/Uniqway%20Offsetting%20Program/image_59_kpuuxy.png`}/>
                                                        </div>
                                                        <div className="font-bold">
                                                            <h2 className="count-title text-primary">{numberOfContributions}</h2>
                                                            <p className="sml  my-0">Transactions</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div key="2" >
                                                <div className="w-100 icn-shdw-bx">
                                                    <div>
                                                        <div className="img-cover img-1">
                                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1643268656/Enterprise/Uniqway%20Offsetting%20Program/image_58_qeugi6.png`} />
                                                        </div>
                                                        <div className="font-bold">
                                                            <h2 className="count-title text-primary">{carbonOffsetImpact} Kg</h2>
                                                            <p className="sml my-0">of CO2 Offset</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div key="3" >
                                            <div className="w-100 icn-shdw-bx">
                                                    <div>
                                                        <div className="img-cover img-1">
                                                            <img src={`https://res.cloudinary.com/carbonclick/image/upload/f_auto,q_auto/v1643268656/Enterprise/Uniqway%20Offsetting%20Program/image_57_o2pqth.png`} />
                                                        </div>
                                                        <div className="font-bold">
                                                            <h2 className="count-title text-primary">{treeGrowthYears}</h2>
                                                            <p className="sml my-0">Tree growth years
                                                                <Popover content={treeMetric} >
                                                                    <img className="ml-1" src={`https://res.cloudinary.com/carbonclick/image/upload/v1643369972/Enterprise/Uniqway%20Offsetting%20Program/tooltip_nj5pma.svg`} alt=""/>
                                                                </Popover>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Carousel>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="offsetSection bg-white">
                <div className="container text-center">
                    <div className="center">
                        <h2 className="mt-0">Offset some or all of your carbon footprint with <br/>high quality carbon offsetting projects</h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <div className="imgBoxOffset text-left h-100">
                                <h2 className="text-white">What is Carbon Offsetting</h2>
                                <p>Carbon offsetting allows bsuinesses or individuals to <br/>balance their carbon footprint by purchasing carbon <br/>credits from projects that fight climate change. </p>
                            </div>
                        </div>
                        <div className="col-md-6 mb-2">
                            <div className="colorBoxOffset text-left">
                                <p className="mb-3">In simple terms, offsetting one tonne of CO2 means there <br/>will be one less tonne of CO2 in the atmosphere than there <br/>would otherwise have been.</p>
                                <p>Projects that plant and preserve forests draw down carbon <br/>from the atmosphere, while renewable energy projects <br/>avoid carbon emissions by replacing fossil fuels. One carbon <br/>credit equals one tonne of emissions reduced or avoided, <br/>which can be used to offset emissions. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="oneTimeOffcetSection bg-white">
                <div className="container text-center">
                    <div className="center title">
                        <h2 className="mt-0">Make a one-time Offset</h2>
                        <p className="text-color mdm">Help the planet with a simple click! You can select one of our<br/> recommended one-off contributions and start offsetting now.</p>
                    </div>

                    <div className="col-lg-12">
                        <div className="text-center">
                            <div className="row mobile-hide">

                                {oneOfConfig && oneOfConfig[selectedCountry]?.oneOff.map((el) => (
                                    <div className="col-4 d-grid" key={el.amount}>
                                        <div className="w-100 icn-shdw-bx box-shadow">
                                            <div className="img-cover img-1 w-100">
                                                <img src={el.src}/>
                                            </div>
                                            <div className="font-bold">
                                                <h6 className="count-title text-primary">${el.price} contribution</h6>
                                                <p className="sml my-0 pb-4">Offset about {el.amount} KG of CO2</p>
                                                <button className="btn-primary" onClick={() => {
                                                    showModal();
                                                    setSelectedOneOff(el.price)
                                                }}>Offset Now</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                            <div className="mobile-show mt-4 text-center">
                                <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>
                                    
                                    {oneOfConfig && oneOfConfig[selectedCountry]?.oneOff.map((el) => {
                                        return (
                                            <div className="w-100 icn-shdw-bx" key={el.amount}>
                                                <div className="img-cover img-1 w-100">
                                                    <img src={el.src}/>
                                                </div>
                                                <div className="font-bold">
                                                    <h6 className="count-title text-primary">${el.price} contribution</h6>
                                                    <p className="sml my-0 pb-4">Offset about {el.amount} KG of CO2</p>
                                                    <button className="btn-primary" onClick={() => {
                                                        showModal();
                                                        setSelectedOneOff(el.price)
                                                    }}>Offset Now</button>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </Carousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="calculateFootprint">
                <div className="container">
                    <div className="formBox center">
                        <h2 className="">Do you want to learn more about your<b/> environmental impact?</h2>
                        <a target="_blank" href={`${process.env.MY_CC_URL}/calculator`} className="btn-primary">Calculate your Footprint</a>
                    </div>
                </div>
            </div>

            <div className="calculateFlightprint">
                <div className="container">
                    <div className="center title">
                        <h2 className="mt-0 text-white px-2">If You Know Your Itinerary,<br/> Calculate Your Flight Emissions</h2>
                    </div>

                    <section className="bg-secondary py-5 mobile-p-0" id="FlightCalculator">
                        <div className="container mobile-p-0 ">
                            <div className="center mag-flight-calculator-wrapper">
                                <FlightCalculator merchantCode={merchantCode} />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            {Array.isArray(projects) && (
            <div className="projectsSection">
                <div className="container container-cus">
                    <div className="projects-sec">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h2>Support Projects That Fight Climate Change</h2>
                                <p>We support only the highest quality carbon offsetting projects around the <br/>world, to bring you peace of mind and results.</p>
                            </div>
                            <div className="col-md-12">
                                <ProjectsList title={null} projects={projects} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            <div className="faq-sec">
                <div className="container">
                    <div className="row faq-bg">
                        <div className="col-md-6">
                            
                        </div>
                        <div className="col-md-6 pb-5">
                            <h2>Climate Friendly FAQs</h2>
                            <div className="mb-30 center text-align-start">
                                <Accordian title={"Who are CarbonClick?"} >
                                    CarbonClick is a New Zealand technology company that exists to reverse climate change. By making carbon offsetting simple, trustworthy and cost effective,  we empower businesses and their customers with the tools to start tackling their carbon emissions.
                                </Accordian>
                                <Accordian title={"How are flight emissions calculated?"} >
                                <span className="mb-2 d-block">CarbonClick calculates the carbon emissions of flights through the use of the IATA emissions factors, an international standard in emissions calculations.</span>A point of contention in calculating the emissions of flights is ‘Radiative Forcing’, this related to the effects vapours and aerosols have when released in high atmosphere in forming clouds, due to the ongoing debate in the scientific community CarbonClicks calculations do not currently include the effects of radiative forcing.
                                </Accordian>
                                <Accordian title={"What are carbon credits?"} >
                                    A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.
                                </Accordian>
                                <Accordian title={"Where does the money go?"} >
                                    The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.
                                </Accordian>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <Footer />

            {selectedOneOff && (
            // loader
            <Modal small={true} handleClose={() => setIsModalVisible(false)} show={isModalVisible}>
                <section className="mb-3 h-100">
                    <iframe
                        frameBorder="0"
                        allowFullScreen
                        src={`${process.env.MY_CC_URL}/RM-BES_NZ_UNIQWAY/purchase-offset?currency=NZD&cost=${selectedOneOff}`}>
                    </iframe>
                </section>
            </Modal>
        )}
        </div> 
    )
}


export default LandingPage;